import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { hasRole, isConsultantOrHolding } from "@/js/http/auth";
import { listUserGroups, casingWines } from "@/js/lists.ts";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import { filterDecimal2digitsKeyAllowNegative } from "@/js/events/keycodes.js";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import { getFullNameUser } from "@/js/user/user.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import WineNaming from "@/components/products/WineNaming.vue";
import ScheduledWineConditionalDiscountsModal from "@/components/conditionaldiscount/ScheduledWineConditionalDiscountsModal.vue";
import PricePostedUsaEditModal from "@/components/price-posting/usa-pro/PricePostedUsaEditModal.vue";
export default {
  name: "ConditionalDiscountModal",
  props: {
    wineId: {
      type: Number,
      default: 0
    }
  },
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    "wine-naming": WineNaming,
    ScheduledWineConditionalDiscountsModal: ScheduledWineConditionalDiscountsModal,
    PricePostedUsaEditModal: PricePostedUsaEditModal
  },
  data: function data() {
    return {
      shown: false,
      isLoading: false,
      isAdding: false,
      options: {
        color: "primary",
        zIndex: 2000
      },
      canManagePricePosting: false,
      panel: [1, 2, 3],
      isInputPrice: true,
      newValue: null,
      priceTargetCountryId: null,
      form: {
        userGroups: ["HORECA"],
        userId: null,
        consultantId: null,
        list_id_countries: [226],
        list_id_wines: [],
        list_id_wineries: [],
        bottle_treshold: null,
        percentage_fee: null,
        price: null
      },
      listCountries: [],
      listThresholds: [{
        value: 6,
        label: "6 bottles"
      }, {
        value: 12,
        label: "12 bottles"
      }, {
        value: 36,
        label: "36 bottles"
      }, {
        value: 60,
        label: "60 bottles"
      }, {
        value: 120,
        label: "120 bottles"
      }, {
        value: 300,
        label: "300 bottles"
      }],
      wine: null,
      headers: [{
        text: "Country",
        value: "country.printable_name",
        align: "left"
      }, {
        text: "Group / User / Consultant",
        value: "user_group",
        align: "left"
      }, {
        text: "Min quantity",
        value: "bottle_treshold",
        align: "center"
      }, {
        text: "New commission (%)",
        value: "percentage_fee",
        align: "center"
      }, {
        text: "Pro FR (incl. ship.)",
        value: "display_price",
        align: "center"
      }, {
        text: "Pro US (incl. ship.)",
        value: "display_price_us",
        align: "center"
      }, {
        text: "",
        value: "action",
        align: "right"
      }],
      commissions_headers: [{
        text: "Product",
        value: "wine",
        align: "left"
      }, {
        text: "Producer",
        value: "winery",
        align: "left"
      }, {
        text: "Country",
        value: "country",
        align: "left"
      }, {
        text: "Group / User / Consultant",
        value: "user_group",
        align: "left"
      }, {
        text: "Commission (%)",
        value: "percentage_fee",
        align: "center"
      }, {
        text: "Pro FR (incl. ship.)",
        value: "display_price",
        align: "center"
      }, {
        text: "Pro US (incl. ship.)",
        value: "display_price_us",
        align: "center"
      }],
      wineDiscountsPricesPostedHeaders: [{
        text: "Status",
        value: "status",
        align: "center"
      }, {
        text: "Application Month",
        value: "applicationMonth",
        align: "center"
      }, {
        text: "Min quantity",
        value: "bottleThreshold",
        align: "center"
      }, {
        text: "Price Discounted Incl. Shipp.",
        value: "priceDiscountUsdDefaultShippingIncluded",
        align: "center"
      }],
      isScheduledDiscountsModalShown: false,
      gettingUserList: {
        results: [],
        isPending: true
      },
      gettingConsultantList: {
        results: [],
        cancellationToken: null,
        isPending: true
      },
      rules: formRules,
      listUserGroups: listUserGroups,
      casingWines: casingWines,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    derivedUserGroups: function derivedUserGroups() {
      return [{
        id: "HORECA",
        value: listUserGroups.find(function (x) {
          return x.id === "HORECA";
        }).name
      }, {
        id: "WHOLESALER",
        value: listUserGroups.find(function (x) {
          return x.id === "WHOLESALER";
        }).name
      }, {
        id: "USER",
        value: listUserGroups.find(function (x) {
          return x.id === "USER";
        }).name
      }];
    },
    isInvalidForm: function isInvalidForm() {
      var nullishPredicate = function nullishPredicate(x) {
        return x.bottle_treshold <= 0 || x.newValue <= 0;
      };
      if (nullishPredicate(this.form)) return true;
      return false;
    },
    isInvalidList: function isInvalidList() {
      return this.items.filter(function (x) {
        return x.bottle_treshold <= 0 || x.newValue <= 0;
      }).length > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.canManagePricePosting = hasRole(process.env.VUE_APP_ROLES_MANAGE_PRICE_POSTING);
            _this2.getUserList();
            _this2.getConsultantList();
            _this2.isLoading = true;
            _this2.form.list_id_wines = [_this2.wineId];
            _this = _this2;
            Promise.all([_this.getCountries(), _this.getDiscounts()]).then(function () {
              _this.isLoading = false;
            });
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    open: function open() {
      this.shown = true;
    },
    close: function close() {
      this.shown = false;
      this.$emit("closed");
    },
    getFormattedMonthYear: function getFormattedMonthYear(date) {
      if (!(date instanceof Date)) {
        date = new Date(date);
      }
      return date.formatStringMonth();
    },
    getUserList: function getUserList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, values;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.gettingUserList.results = [];
              _this3.gettingUserList.isPending = true;
              _this = _this3;
              _context2.next = 5;
              return request("/v1/third-party-users", "get", {}, true, "api").catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available users", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 5:
              response = _context2.sent;
              values = _toConsumableArray(response.data.value);
              values.forEach(function (user) {
                var _listUserGroups$find;
                var fullName = getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.login + ")";
                _this3.gettingUserList.results.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this3.gettingUserList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this3.gettingUserList.isPending = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getConsultantList: function getConsultantList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$gettingConsult;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.gettingConsultantList.isPending = true;
              (_this4$gettingConsult = _this4.gettingConsultantList.cancellationToken) === null || _this4$gettingConsult === void 0 || _this4$gettingConsult.cancel();
              _this4.gettingConsultantList.cancellationToken = axios.CancelToken.source();
              data = {
                isConsultantOrHolding: true,
                active: true
              };
              _this = _this4;
              _context3.next = 7;
              return request("/v1/users", "post", data, true, "api", null, _this.gettingConsultantList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available consultants", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context3.sent;
              response.data.users.forEach(function (user) {
                _this4.gettingConsultantList.results.push({
                  id: user.id_user,
                  full_name: getFullNameUser(user) + " - " + user.delivery_country_iso_code + " - " + user.consultant_code + " (" + user.login + ")"
                });
              });
              _this4.gettingConsultantList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this4.gettingConsultantList.isPending = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getCountries: function getCountries() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this5;
              _context4.next = 3;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of countries", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 3:
              response = _context4.sent;
              _this5.listCountries = _toConsumableArray(response.data.countries);
              _this5.priceTargetCountryId = _this5.listCountries.find(function (x) {
                return x.iso_2 == "US";
              }).id_country;
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getDiscounts: function getDiscounts() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this = _this6;
              _context5.next = 3;
              return request("/v1/conditionals-discounts/".concat(_this6.wineId), "get", null, true, "api").then(function (response) {
                _this.wine = _objectSpread(_objectSpread({}, response.data.value), {}, {
                  discounts: response.data.value.discounts.map(function (x) {
                    return _objectSpread(_objectSpread({}, x), {}, {
                      price_ex_vat: parseFloat((response.data.value.salePrice + response.data.value.salePrice * (x.percentage_fee / 100)).toFixed(2)),
                      isDeleting: false
                    });
                  }),
                  commissions: response.data.value.commissions.map(function (x) {
                    var _listUserGroups$find$, _listUserGroups$find2, _x$consultant, _x$user;
                    return _objectSpread(_objectSpread({}, x), {}, {
                      country: x.country.id_country == 0 ? "All" : x.country.printable_name,
                      user_group: (_listUserGroups$find$ = (_listUserGroups$find2 = listUserGroups.find(function (group) {
                        return group.id === x.user_group;
                      })) === null || _listUserGroups$find2 === void 0 ? void 0 : _listUserGroups$find2.name) !== null && _listUserGroups$find$ !== void 0 ? _listUserGroups$find$ : (_x$consultant = x.consultant) !== null && _x$consultant !== void 0 && _x$consultant.id_user ? getFullNameUser(x.consultant) : (_x$user = x.user) !== null && _x$user !== void 0 && _x$user.id_user ? getFullNameUser(x.user) : "All",
                      winery: !x.id_winery ? "All" : response.data.value.producer.name,
                      wine: !x.id_wine ? "All" : response.data.value.appellation,
                      percentage_fee: x.percentage_fee,
                      price_ex_vat: parseFloat((response.data.value.salePrice + response.data.value.salePrice * (x.percentage_fee / 100)).toFixed(2))
                    });
                  })
                });
                _this.form.list_id_wineries = [_this.wine.producer.id];
              }).catch(function () {
                _this.$toasted.show("Unable to load the conditionals discounts.", {
                  type: "error"
                });
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    save: function save() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.isAdding = true;
              if (_this7.isInputPrice) {
                _this7.form.percentage_fee = null;
                _this7.form.price = _this7.newValue;
                _this7.form.priceTargetCountryId = _this7.priceTargetCountryId;
              } else {
                _this7.form.percentage_fee = _this7.newValue;
                _this7.form.price = null;
                _this7.form.priceTargetCountryId = null;
              }
              if (!(_this7.form.userGroups.length > 0)) {
                _context6.next = 6;
                break;
              }
              _this7.form.userGroups.forEach(function (userGroup) {
                return _this7.addDiscount(userGroup);
              });
              _context6.next = 8;
              break;
            case 6:
              _context6.next = 8;
              return _this7.addDiscount();
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    addDiscount: function addDiscount(userGroup) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var commission, _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              commission = _objectSpread({}, _this8.form);
              if (userGroup) {
                commission = _objectSpread(_objectSpread({}, commission), {}, {
                  user_group: userGroup
                });
              }
              _this = _this8;
              _context8.next = 5;
              return request("/v1/commission", "post", commission, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return _this.getDiscounts();
                    case 2:
                      _this.isAdding = false;
                      _this.form.bottle_treshold = null;
                      _this.form.percentage_fee = null;
                      _this.form.price = null;
                      _this.newValue = null;
                      _this.$toasted.show("Discount successfully added.", {
                        type: "success"
                      });
                    case 8:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              }))).catch(function (e) {
                _this.isAdding = false;
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                throw e;
              });
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    deleteDiscount: function deleteDiscount(item) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = _this9;
              item.isDeleting = true;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this discount ?", {
                color: "red"
              }).then(function (confirm) {
                if (confirm) {
                  request("/v1/commission/" + item.id_commission, "delete", null, true, "api").then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
                    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          _this.wine.discounts.splice(_this.wine.discounts.indexOf(item), 1);
                          _this.getDiscounts();
                          _this.$toasted.show("Discount deleted.", {
                            type: "success"
                          });
                        case 3:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee9);
                  }))).catch(function () {
                    item.isDeleting = false;
                  });
                } else {
                  item.isDeleting = false;
                }
              });
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    openPricesPostingEditModal: function openPricesPostingEditModal() {
      var _this10 = this;
      this.$nextTick(function () {
        _this10.$refs.PricePostedUsaEditModalRef.open();
      });
    },
    openScheduledDiscounts: function openScheduledDiscounts() {
      var _this11 = this;
      this.isScheduledDiscountsModalShown = true;
      this.$nextTick(function () {
        _this11.$refs.ScheduledDiscountsModal.open();
      });
    },
    closeScheduledDiscounts: function closeScheduledDiscounts() {
      this.isScheduledDiscountsModalShown = false;
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    getFullNameUser: getFullNameUser,
    filterDecimal2digitsKeyAllowNegative: filterDecimal2digitsKeyAllowNegative
  }
};